<div class="container-fluid">
  <div class="row">
    <div class="col-12 p-2">
      <button class="c-p font-weight-bold close close-btn" (click)="close()">
        <i class="pi pi-times"></i>
      </button>
    </div>
    <div class="col-12 text-center mb-4 comfortaa">
      <p class="text-center" *ngIf="config.data.type === 'success' || 'print'">
        <i class="fas fa-check icon-borders bg-success-icon text-white"></i>
      </p>
      <p class="text-center" *ngIf="config.data.type === 'fail'">
        <i class="fas fa-times icon-borders bg-danger-icon text-white"></i>
      </p>
      <p class="font-11 font-weight-lighter my-4">{{ config.data.content }}</p>
      <ng-container *ngIf="config?.data?.errorInfo?.length > 0">
        <div class="text-left">
          <ul class="font-weight-lighter">
            <p class="font-weight-bold my-1" style="color:#530505">{{ "Some coupons gave an error" | translate }}</p>
            <li style="color:#530505" *ngFor="let error of config?.data?.errorInfo">{{ error.couponData.bet |
              bettingType:error?.couponData?.Country | translate | capitalizeFirst }}{{': '}}{{ error.message |translate
              }}
            </li>
          </ul>
        </div>
      </ng-container>

      <button class="btn {{config.data.type === 'print'?'btn-outline-secondary':'btn-yellow'}} px-5 font-weight-bold"
        (click)="close()">
        {{ "GENERAL.CLOSE" | translate }}
      </button>
      <button class="btn btn-yellow px-5 ml-4 font-weight-bold" *ngIf="config.data.type === 'print'" (click)="print()">
        {{ "GENERAL.PRINT" | translate }}
      </button>
    </div>
  </div>
</div>